// extracted by mini-css-extract-plugin
export default {"container":"Header_container__bIqEA","title":"Header_title__Emesq","header":"Header_header__w5Kj2","arrow":"Header_arrow__ciykK","desc":"Header_desc__UcHYO"};